import { render } from "./RengongYlqRwPrintContent.vue?vue&type=template&id=3f704f7e"
import script from "./RengongYlqRwPrintContent.vue?vue&type=script&lang=js"
export * from "./RengongYlqRwPrintContent.vue?vue&type=script&lang=js"

import "./RengongYlqRwPrintContent.vue?vue&type=style&index=0&id=3f704f7e&lang=css"

import exportComponent from "F:\\allNewWeb\\ant-vue\\antd-demo2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__